import { EapSettingsCreateModel } from '../settings-devices-eap-settings-form.model';
import {
    CreateEapSettingsApiRequest,
    UpdateEapSettingsApiRequest,
} from 'modules/settings/pods/settings-devices/settings-devices-eap-settings/service/eap-settings-rest.api';

export const mapEapSettingsFormModelToApiRequest = (data: EapSettingsCreateModel): CreateEapSettingsApiRequest => {
    const newData = {
        eapContent: {
            name: data.name,
            ssid: data.ssid,
            cipherType: data.cipherType,
            eapType: data.eapType,
            anonymousUser: data.anonymousUser,
            caCertificateFilename: data.caCertificateFilename || '',
            clientCertificateFilename: data.clientCertificateFilename || '',
            clientPrivateKeyFilename: data.clientPrivateKeyFilename || '',
            username: data.username,
            password: data.password,
        },
        caCertificate: data.caCertificate || undefined,
        clientCertificate: data.clientCertificate || undefined,
        clientPrivateKey: data.clientPrivateKey || undefined,
    };
    return newData;
};

export const mapEapSettingsFormModelToUpdateApiRequest = (
    data: EapSettingsCreateModel
): UpdateEapSettingsApiRequest => {
    const newData = {
        eapContent: {
            id: data.id,
            ssid: data.ssid,
            cipherType: data.cipherType,
            eapType: data.eapType,
            anonymousUser: data.anonymousUser,
            caCertificateFilename: data.caCertificateFilename || '',
            clientCertificateFilename: data.clientCertificateFilename || '',
            clientPrivateKeyFilename: data.clientPrivateKeyFilename || '',
            username: data.username,
            password: data.password,
        },
        caCertificate: data.caCertificate || undefined,
        clientCertificate: data.clientCertificate || undefined,
        clientPrivateKey: data.clientPrivateKey || undefined,
    };
    return newData;
};
